<div class="reset-wrapper">
          <!-- <img src="assets/logoremovebg.png"class="logo-img" alt="Logo"  /> -->
          <!-- <div class="complinity-icon">

          </div> -->

  
  <!-- Icon Circle -->
  
  <div class="icon-circle">
        <img src="assets/bluelogoremovebg.png"  class="logo-img" alt="Logo"  />


    <!-- <i class="pi pi-key"></i> -->
  </div>

  <div class="reset-card">
    <h2>Reset Password</h2>

    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">

      <input type="password"
             placeholder="New Password"
             formControlName="password"
             class="input-box"
             (input)="checkPasswordStrength();checkconfirmPassword()" />

      <input type="password"
             placeholder="Confirm New Password"
             formControlName="confirmPassword"
             class="input-box" (input)="checkconfirmPassword()"/>
             <!-- <span class="colorred" *ngIf="invalidconfrimpswd"> Confrim Password not matched</span> -->

      <div class="button-group">
        <button type="submit"
                class="continue-btn"
                [disabled]="!resetForm.valid || !allRulesPassed()">
          Continue
        </button>
        <button class="cancel-btn" type="button" routerLink="/login">Cancel</button>
      </div>

    </form>

    <div class="rules-box">
      <p>Password must contain the following:</p>
      <ul>
        <li *ngFor="let rule of ruleList">
          <i class="pi"
             [ngClass]="rule.check ? 'pi-check-circle valid-icon' : 'pi-times-circle invalid-icon'">
          </i>
          <span [ngClass]="rule.check ? 'valid-text' : 'invalid-text'">
            {{ rule.label }}
          </span>
        </li>
      </ul>
    </div>

  </div>
</div>
